export const environment = {
  messagingServiceBaseUrl: 'https://qa.customer-api.deliverysolutions.co/api/v2/messaging',
  production: false,
};
